module.exports = __webpack_public_path__ + "static/media/m_beard_long_diamond__v_shadow.9f10895a.png";